import React, { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_CAMPAIGN } from "../../utils/api/campaign";
import Spinner from "../../components/icons/Spinner";
import { message } from "antd";

const CampaignRoot = ({marketplace = false}) => {
  const { campaignId } = useParams();
  const navigate = useNavigate()
  const { loading, error, data, ...rest } = useQuery(GET_CAMPAIGN, {
    variables: { campaignId },
  });

  useEffect(() => {
    if (!loading && (data === undefined || data.campaign === null)) {
      message.error({
        content: error?.networkError
          ? `Couldn't load this campaign. Check your connection and try again.`
          : `This campaign no longer exists or you don't have access to it.`,
      })
      navigate(marketplace ? '/marketplace-campaigns' : '/campaigns')
    }
  }, [loading, data])

  if (loading || data === undefined || data.campaign === null) {
    return <Spinner />;
  }

  return <Outlet context={{ campaign: data.campaign, marketplace }} />;
};

export default CampaignRoot;
